import cf from './cf';
import c00v2 from './c00v2_20211024';

export default class c00v2a extends c00v2 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      class: 'c00v2a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
